/**
 * Pure fetch helper extracted from `useAddSpaceSource` so the hook itself can
 * stay focused on the React-state / sweet-state mirroring concerns and the
 * shared `useMutation` utility can drive the request lifecycle.
 */
import { performHttpFetch } from '@atlassian/conversation-assistant-utils/httpUtils';

import { SPACES_API_PATH } from '../../common/constants';
import type { SpaceSourceResponse } from '../../controllers/space-store/types';

export type AddSpaceSourceRequest = {
	/** The ARI of the source, or the URL for external links with no resolved entity ARI. */
	ari: string;
	url: string;
	/** The source type (e.g. 'confluence', 'jira'). */
	sourceType?: string;
	/** Human-readable display name for the source. */
	name?: string | null;
};

export type AddSpaceSourceFetchParams = {
	spaceId: string;
	request: AddSpaceSourceRequest;
	cloudId: string;
	product: string;
	experienceId: string;
};

export const addSpaceSourceFetchAction = async ({
	spaceId,
	request,
	cloudId,
	product,
	experienceId,
}: AddSpaceSourceFetchParams): Promise<SpaceSourceResponse> =>
	performHttpFetch({
		path: `${SPACES_API_PATH}/${spaceId}/sources`,
		options: {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'x-cloudid': cloudId,
				'x-product': product,
				'x-experience-id': experienceId,
			},
			credentials: 'include',
			body: JSON.stringify(request),
		},
	});
